goog.provide('el8.data.educationalHandouts');

goog.require('el8.model.base');
goog.require('el8.service.urls');
goog.require('el8.util.string');

el8.data.educationalHandouts = (function() {

    var _class = function(spec) {
        spec['model_class'] = 'Handout';
        spec['tags'] = spec.tags ? spec.tags.map(function(a) { return a; }) : [];
        this.populate(spec);
    };
    _class.inheritsFrom(el8_Entity);
    _class.addStringProperty('name');
    _class.addStringProperty('url');
    _class.addProperty('tags');  // an Array of strings
    _class.addBoolean('shared'); // true for Elation-created / cross-practice handouts

    _class.prototype.getNoteSummary = function() {
        // don't change this string without also verifying the HAXX in
        // mu_stats.apply_handouts and APP-2914
        return 'Handout: '+this.getName();
    };

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        deleteFn: function(item, successCb, errorCb, opts) {
            $.el8_ajax({
                type: 'DELETE',
                url: el8.service.urls.get('educationalHandouts', [item.getId()]),
                success: successCb,
                error: errorCb
            });
        },
        sortFn: function(a, b) {
            return el8.util.string.cmp(a.getName().toLowerCase(), b.getName().toLowerCase());
        },
        urlLoad: function() {
            return el8.service.urls.get('getEducationalHandouts');
        },
        urlFn: function(id) {
            return el8.service.urls.get('educationalHandouts', [id]);
        }
    });

    that.downloadById = function(handoutId) {
        window.open(el8.service.urls.get('downloadEducationalHandout', [handoutId]));
    };

    return that;

})();
